import PropTypes from 'prop-types'
import {List} from 'immutable'

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

import './formLevelErrors.scss'

export const DEFAULT_FORM_LEVEL_ERROR = 'Please address the issues above and try again.'

const FormLevelErrors = ({errors = List()}) => {
  if (errors.isEmpty())
    return null

  return (
    <div className='form-level-errors' role='alert'>
      <div className='form-level-errors-content'>
        <ErrorOutlineIcon className='form-level-errors-icon' />
        <div className='form-level-errors-messages'>
          {errors.map(error => <p className='error-text' key={error}>{error}</p>)}
        </div>
      </div>
    </div>
  )
}

FormLevelErrors.propTypes = {
  errors: PropTypes.instanceOf(List)
}

export default FormLevelErrors
